<template>
    <div class="row align-items-center py-2">
        <div class="col-12">
            <p class="lead text-primary font-weight-bold mb-0">
                {{ commitments.title }}
            </p>
        </div>
        <div class="col-5 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-voucher-tag" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment1Link"
                        data-oevent-category="footer"
                        data-oevent-action="promos_exclusives"
                        :data-oevent-label="commitments.commitment1Link"
                        v-html="commitments.commitment1Text"
                    />
                </div>
            </div>
        </div>
        <div class="col-7 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-Safety" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment2Link"
                        data-oevent-category="footer"
                        data-oevent-action="paiement_100_securise"
                        :data-oevent-label="commitments.commitment2Link"
                        v-html="commitments.commitment2Text"
                    />
                </div>
            </div>
        </div>
        <div class="col-5 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-Fast-delivery" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment3Link"
                        data-oevent-category="footer"
                        data-oevent-action="livraison_gratuite"
                        :data-oevent-label="commitments.commitment3Link"
                        v-html="commitments.commitment3Text"
                    />
                </div>
            </div>
        </div>
        <div class="col-7 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-store-locator" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment4Link"
                        data-oevent-category="footer"
                        data-oevent-action="retrait_sous_2h_d_un_mobile_en_boutique"
                        :data-oevent-label="commitments.commitment4Link"
                        v-html="commitments.commitment4Text"
                    />
                </div>
            </div>
        </div>
        <div class="col-5 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-control-centre" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment5Link"
                        data-oevent-category="footer"
                        data-oevent-action="a_vos_cotes_24h24"
                        :data-oevent-label="commitments.commitment5Link"
                        v-html="commitments.commitment5Text"
                    />
                </div>
            </div>
        </div>
        <div class="col-7 col-md-4 col-xl-2 pt-1">
            <div class="media text-white">
                <span class="mr-1 align-self-center icon h1 mb-0 pb-0 icon-calendar-21" />
                <div class="media-body align-self-center">
                    <a
                        class="d-block text-white o-link-arrow"
                        :href="commitments.commitment6Link"
                        data-oevent-category="footer"
                        data-oevent-action="droit_de_retractation__21_jours"
                        :data-oevent-label="commitments.commitment6Link"
                        v-html="commitments.commitment6Text"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        commitments: {
            type: Object,
            required: true,
        }
    }
}
</script>
